<template>
  <div>
    <el-alert
      title="显示可用量低于产品安全库存的库存行。请在产品管理维护安全库存。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.materialCode" clearable placeholder="产品编码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.materialName" clearable placeholder="产品名称" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.wareHouseId" clearable filterable placeholder="仓库" style="width:160px">
        <el-option v-for="w in warehouses" :key="w.wareHouseId" :label="w.wareHouseName" :value="w.wareHouseId" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="materialCode" label="产品编码" width="140" />
      <el-table-column prop="materialName" label="产品名称" min-width="160" show-overflow-tooltip />
      <el-table-column prop="wareHouseName" label="仓库" width="140" />
      <el-table-column prop="wareAreaName" label="库位" width="110" show-overflow-tooltip />
      <el-table-column prop="palletCode" label="托盘" width="110" show-overflow-tooltip />
      <el-table-column prop="usableQuantity" label="可用量" width="110" align="right" />
      <el-table-column prop="safetyStock" label="安全库存" width="110" align="right" />
      <el-table-column prop="warningQuantity" label="缺口" width="110" align="right" />
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listStockWarning } from '../../api/quantity'
import { selectEnabledWareHouse } from '../../api/warehouse'

export default {
  components: { ListPagination },
  data() {
    return {
      query: { materialCode: '', materialName: '', wareHouseId: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false, warehouses: []
    }
  },
  created() {
    this.load()
    selectEnabledWareHouse().then(res => { this.warehouses = res.data || [] }).catch(() => {})
  },
  methods: {
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listStockWarning({
        currentPage: this.page, pageSize: this.pageSize,
        materialCode: this.query.materialCode,
        materialName: this.query.materialName,
        wareHouseId: this.query.wareHouseId
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    }
  }
}
</script>
